import { render, staticRenderFns } from "./RegistrationAdditionalInfoPage.vue?vue&type=template&id=67823f18"
import script from "./RegistrationAdditionalInfoPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationAdditionalInfoPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationAdditionalInfoPage.vue?vue&type=style&index=0&id=67823f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports